export default __webpack_public_path__ + "static/media/uploader-insuletOmnipod-2.d5ec63fb.png";